import React, { useEffect, useRef, useState } from "react";
import { useAuth as useOidcAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import { useAuth as useCustomAuth } from "../../auth/AuthContext";
import CommonObj from "../../CommonObj";
import configJson from "../../Config.json";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";
import { trackUserSessionLogin } from "../../services/userSessionAuditService";

const SignInOidc = () => {
  const oidcAuth = useOidcAuth();
  const { setUserWithRoles, fetchAuditLogConfig } = useCustomAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const hasTracked = useRef(false);
  const hasFetchedAuditLogConfig = useRef(false);

  useEffect(() => {
    const fetchUserRoles = async () => {
      if (oidcAuth.isAuthenticated) {
        const userName =
          oidcAuth.user?.profile["cognito:username"] ||
          oidcAuth.user?.profile?.sub;

        try {
          const response = await fetch(CommonObj.Endpoints.LoginRoles, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${oidcAuth.user?.access_token}`,
              "X-CSRF-Token": encryptTimestamp()
            },
            //body: JSON.stringify({ userName, email: "" }),
          });
          if (response.status === 403) {
            setLoading(false);
            localStorage.clear();
            sessionStorage.clear();
            localStorage.setItem('errorPage', 'invaliduser');
            const logoutUri = `${configJson.logout_uri}`;
            window.location.href = `${configJson.cognitoDomain}/logout?client_id=${configJson.client_id
              }&logout_uri=${encodeURIComponent(logoutUri)}`;
            //navigate("/failed-authorization");
          }
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();

          // Format the API response to match your context structure
          // API returns: { roleId: 1, roleName: "Super Admin" }
          const userData = {
            username: userName,
            email: oidcAuth.user?.profile?.email || "",
            name: oidcAuth.user?.profile?.name || userName,
          };

          // Convert single role object to array format
          const roles = [
            {
              roleId: data.roleId,
              roleName: data.roleNames,
              userId: data.userId,
              userName: data.displayName,
              menuname: data.menuNames,
              tilename: data.tileNames,
            },
          ];

          if (!hasTracked.current) {
            hasTracked.current = true;
            try {
              const sessionId = await trackUserSessionLogin({
                accessToken: oidcAuth.user?.access_token,
                userId: data.userId,
              });
              if (sessionId !== null) {
                localStorage.setItem("sessionID", sessionId);
              }
            } catch (auditError) {
              console.warn("UserSessionLogin tracking failed", auditError);
            }
          }

          if (!hasFetchedAuditLogConfig.current) {
            hasFetchedAuditLogConfig.current = true;
            fetchAuditLogConfig();
          }

          setUserWithRoles(userData, roles);

          setLoading(false);
          navigate("/home");
        } catch (error) {
          console.error("Failed to fetch user roles", error);
          setLoading(false);
        }
      }
    };

    fetchUserRoles();
  }, [oidcAuth.isAuthenticated, oidcAuth.user, navigate, setUserWithRoles]);

  if (loading) {
    return <div>Loading user info...</div>;
  }

  return <div>Signing you in...</div>;
};

export default SignInOidc;
